export default "/Frontend/dist/ppt-black.4615497ae027cf6fc214d7fcaa2f933f.svg";